import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => {
    if (path === "") return location.pathname === "/";
    return location.pathname === `/${path}`;
  };

  const handleClick = (path) => {
    navigate(path === "" ? "/" : `/${path}`);
    setIsOpen(false);
  };

  return (
    <nav className="bg-white shadow-lg fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <div onClick={() => handleClick("")} className="cursor-pointer">
              <img
                src="/logo_tax_solution.png"
                alt="Tax Solutions"
                className="h-12"
              />
            </div>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => handleClick("")}
              className={`px-3 py-5 ${
                isActive("")
                  ? "text-cyan-400 border-b-2 border-cyan-400"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              Home
            </button>
            <button
              onClick={() => handleClick("about")}
              className={`px-3 py-5 ${
                isActive("about")
                  ? "text-cyan-400 border-b-2 border-cyan-400"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              About Us
            </button>
            <button
              onClick={() => handleClick("services")}
              className={`px-3 py-5 ${
                isActive("services")
                  ? "text-cyan-400 border-b-2 border-cyan-400"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              Services
            </button>
            <button
              onClick={() => handleClick("faq")}
              className={`px-3 py-5 ${
                isActive("faq")
                  ? "text-cyan-400 border-b-2 border-cyan-400"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              FAQ
            </button>
            <button
              onClick={() => handleClick("contact")}
              className={`px-3 py-5 ${
                isActive("contact")
                  ? "text-cyan-400 border-b-2 border-cyan-400"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              Contact us
            </button>
            <button
              onClick={() => handleClick("contact")}
              type="button"
              className="bg-red-400 text-white px-4 py-2 rounded-lg hover:bg-red-500 transition-colors cursor-pointer"
            >
              (407)-416-9541
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-600"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <button
              onClick={() => handleClick("")}
              className={`block w-full text-left px-3 py-2 ${
                isActive("")
                  ? "text-cyan-400"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              Home
            </button>
            <button
              onClick={() => handleClick("about")}
              className={`block w-full text-left px-3 py-2 ${
                isActive("about")
                  ? "text-cyan-400"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              About Us
            </button>
            <button
              onClick={() => handleClick("services")}
              className={`block w-full text-left px-3 py-2 ${
                isActive("services")
                  ? "text-cyan-400"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              Services
            </button>
            <button
              onClick={() => handleClick("faq")}
              className={`block w-full text-left px-3 py-2 ${
                isActive("faq")
                  ? "text-cyan-400"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              FAQ
            </button>
            <button
              onClick={() => handleClick("contact")}
              className={`block w-full text-left px-3 py-2 ${
                isActive("contact")
                  ? "text-cyan-400"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              Contact us
            </button>
            <button
              onClick={() => handleClick("contact")}
              type="button"
              className="block w-full text-left px-3 py-2 text-red-400 hover:text-red-500 cursor-pointer"
            >
              (407)-416-9541
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
